




















































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class NavigationCard extends Vue {
  @Prop({ default: false }) readonly isHome!: boolean;

  activeCardName = '';

  mouseEnterLink(name: string) {
    this.activeCardName = name;
  }

  mouseLeaveLink() {
    this.activeCardName = '';
  }
}
